import Cookies from 'js-cookie';
import { isBrowser } from 'react-device-detect';
import { or, isNil, isEmpty as isEmpty$1, test, converge, concat, pipe, head, toUpper, tail, curry, path } from 'ramda';
import { EmailValidator } from 'commons-validator-js';
import validator from 'validator';

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  }
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

/**
 * Create new File from Base64 string
 * Works great for all old/modern browsers like IE, EDGE
 * @param url Base 64 as "data:image/jpeg;base64,/..."
 * @param fileName Newly created file name
 */
var fromBase64 = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(url, fileName) {
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", new Promise(function (resolve) {
              var _typeAndContent$0$mat;

              var typeAndContent = url.split(',');
              var mime = typeAndContent === null || typeAndContent === void 0 ? void 0 : (_typeAndContent$0$mat = typeAndContent[0].match(/:(.*?);/)) === null || _typeAndContent$0$mat === void 0 ? void 0 : _typeAndContent$0$mat[1];

              if (!navigator.msSaveBlob) {
                fetch(url).then(function (res) {
                  return res.blob();
                }).then(function (blob) {
                  var file = new File([blob], fileName, {
                    type: mime
                  });
                  resolve(file);
                });
              } else {
                var binaryString = atob(typeAndContent[1]);
                var binaryStringLength = binaryString.length;
                var u8arr = new Uint8Array(binaryStringLength);

                while (binaryStringLength--) {
                  u8arr[binaryStringLength] = binaryString.charCodeAt(binaryStringLength);
                }

                var blob = new Blob([u8arr], {
                  type: mime
                });
                resolve(blob);
              }
            }));

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function fromBase64(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

var formatBytes = function formatBytes(bytes) {
  var decimals = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;

  if (bytes === 0) {
    return '0 Bytes';
  }

  var k = 1024;
  var dm = decimals < 0 ? 0 : decimals;
  var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
  var i = Math.floor(Math.log(bytes) / Math.log(k));
  return "".concat(parseFloat((bytes / Math.pow(k, i)).toFixed(dm)), " ").concat(sizes[i]);
};

var downloadFile = function downloadFile(blob, filename) {
  if (typeof window.navigator.msSaveBlob !== 'undefined') {
    window.navigator.msSaveBlob(blob, filename);
    return;
  }

  var blobURL = window.URL.createObjectURL(blob);
  var tempLink = document.createElement('a');
  tempLink.style.display = 'none';
  tempLink.href = blobURL;
  tempLink.setAttribute('download', filename);

  if (typeof tempLink.download === 'undefined') {
    tempLink.setAttribute('target', '_blank');
  }

  document.body.appendChild(tempLink);
  tempLink.click();
  document.body.removeChild(tempLink);
  setTimeout(function () {
    window.URL.revokeObjectURL(blobURL);
  }, 100);
};

var pushPageVisited = function pushPageVisited(pageTitle, sessionIdInitial) {
  var _window, _window$dataLayer;

  return (_window = window) === null || _window === void 0 ? void 0 : (_window$dataLayer = _window.dataLayer) === null || _window$dataLayer === void 0 ? void 0 : _window$dataLayer.push({
    event: 'pageview',
    pageUrl: window.location.href,
    pageTitle: pageTitle,
    deviceType: isBrowser ? 'desktop' : 'mobile',
    sessionId: Cookies.get('onboarding_workflow_instance_id'),
    sessionIdInitial: sessionIdInitial
  });
};
var pushButtonClicked = function pushButtonClicked(buttonName) {
  var _window2, _window2$dataLayer;

  return (_window2 = window) === null || _window2 === void 0 ? void 0 : (_window2$dataLayer = _window2.dataLayer) === null || _window2$dataLayer === void 0 ? void 0 : _window2$dataLayer.push({
    event: 'button',
    buttonName: buttonName
  });
};
var pushFormAction = function pushFormAction(formAction, formName, errors, errorType) {
  var _window3, _window3$dataLayer;

  var formValidation = errors === 0 ? 'validation OK' : 'error';
  return (_window3 = window) === null || _window3 === void 0 ? void 0 : (_window3$dataLayer = _window3.dataLayer) === null || _window3$dataLayer === void 0 ? void 0 : _window3$dataLayer.push({
    event: 'form',
    formAction: formAction,
    formName: formName,
    formValidation: formValidation !== null && formValidation !== void 0 ? formValidation : '',
    errorType: errorType !== null && errorType !== void 0 ? errorType : ''
  });
};
var pushKeyPress = function pushKeyPress(key) {
  var _window4, _window4$dataLayer;

  return (_window4 = window) === null || _window4 === void 0 ? void 0 : (_window4$dataLayer = _window4.dataLayer) === null || _window4$dataLayer === void 0 ? void 0 : _window4$dataLayer.push({
    event: 'keypress',
    key: key
  });
};
var pushAppSent = function pushAppSent(applicationId) {
  var _window5, _window5$dataLayer;

  return (_window5 = window) === null || _window5 === void 0 ? void 0 : (_window5$dataLayer = _window5.dataLayer) === null || _window5$dataLayer === void 0 ? void 0 : _window5$dataLayer.push({
    event: 'appSent',
    applicationId: applicationId
  });
};

var imageDimensions = function imageDimensions(file) {
  return new Promise(function (resolve, reject) {
    var img = new Image();
    img.src = window.URL.createObjectURL(file);

    img.onload = function () {
      var naturalWidth = img.naturalWidth,
          naturalHeight = img.naturalHeight;
      window.URL.revokeObjectURL(img.src);
      resolve({
        width: naturalWidth,
        height: naturalHeight
      });
    };

    img.onerror = function (error) {
      return reject(error);
    };
  });
};

var internetExplorerTextEncoder = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
    var TextEncodingShim;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!(!window.TextDecoder || !window.TextEncoder)) {
              _context.next = 6;
              break;
            }

            _context.next = 3;
            return import('text-encoding-shim');

          case 3:
            TextEncodingShim = _context.sent;
            // Fix for EDGE (version < 44 (18 engine version))
            window.TextDecoder = window.TextDecoder || TextEncodingShim.TextDecoder;
            window.TextEncoder = window.TextEncoder || TextEncodingShim.TextEncoder;

          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function internetExplorerTextEncoder() {
    return _ref.apply(this, arguments);
  };
}();

var getKeyByValue = function getKeyByValue(object, value) {
  return Object.keys(object).find(function (key) {
    return object[key] === value;
  });
};

var PROTOCOL_VERSION = '1.0';
var SEPARATOR = '*';
var PAYMENT_TYPE;

(function (PAYMENT_TYPE) {
  PAYMENT_TYPE["SINGLE"] = "SPD";
  PAYMENT_TYPE["DIRECT_DEBIT"] = "SCD";
})(PAYMENT_TYPE || (PAYMENT_TYPE = {}));

var paymentKeysMapping = {
  creditAccountIBAN: 'ACC',
  amount: 'AM',
  currency: 'CC',
  transferDate: 'DT',
  message: 'MSG',
  variableSymbol: 'X-VS',
  constantSymbol: 'X-KS',
  specificSymbol: 'X-SS'
};
var generateQrPaymentValue = function generateQrPaymentValue(type, data) {
  var header = type + SEPARATOR + PROTOCOL_VERSION + SEPARATOR;
  var body = Object.entries(data).map(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        key = _ref2[0],
        value = _ref2[1];

    return "".concat(paymentKeysMapping[key], ":").concat(value).concat(SEPARATOR);
  }).join('');
  return header + body;
};

var emailValidator = new EmailValidator();
/**
 * Check if the passed value is undefined|null or not filled
 * @param value
 * @return {boolean} True if value is undefined|null or []|''|{}
 */

var isEmpty = function isEmpty(value) {
  return or(isNil(value), isEmpty$1(value));
};
/**
 * Check if the passed value is defined or filled
 * @param value
 * @return {boolean} True if value is not undefined|null or []|''|{}
 */

var notEmpty = function notEmpty(value) {
  return !isEmpty(value);
};
var isEmail = function isEmail(value) {
  var rgx = new RegExp("^[a-zA-Z0-9.@!#$%&'*+-/=?^_`{|}~]*$");

  if (notEmpty(value)) {
    return test(rgx, value) && emailValidator.isValid(value);
  }

  return true;
};
var isPhoneNumber = function isPhoneNumber(value) {
  if (notEmpty(value)) {
    return validator.matches(value, /^\+42[01] [1-9][0-9]{2} \d{3} \d{3}/);
  }

  return true;
};

var lettersWithDiacritic = 'a-zA-ZáäčďéěíľňóôöřŕšťúůüýžÁÄČĎÉĚÍĽŇÓÔÖŘŔŠŤÚŮÜÝŽ´ˇˆ°¨';
var Regex = {
  lettersWithDiacritic: lettersWithDiacritic
};

var capitalize = converge(concat, [pipe(head, toUpper), tail]);
var maskPhoneNumber = function maskPhoneNumber(phoneNumber) {
  return notEmpty(phoneNumber) ? phoneNumber.replace(/^(\+42[01]) \d{3} \d{3} \d(\d{2})$/, '$1 XXX XXX X$2') : '';
};
var maskEmail = function maskEmail(email) {
  return notEmpty(email) ? email.replace(/^(.).*(.@.).*(.\.\w{2,3})$/, '$1***$2***$3') : '';
};
var filterLetters = function filterLetters(value) {
  return notEmpty(value) ? value.replace(/[^a-zA-Z]+/g, '') : '';
};

var string = /*#__PURE__*/Object.freeze({
  __proto__: null,
  capitalize: capitalize,
  maskPhoneNumber: maskPhoneNumber,
  maskEmail: maskEmail,
  filterLetters: filterLetters
});

var translateError = curry(function (translations, key, error) {
  if (error) {
    var errors = error.errors;
    var errorCodes = error.code.split('.');
    var translatedMessage = path(['validations', key].concat(_toConsumableArray(errorCodes)), translations) || path(errorCodes, translations); // eslint-disable-next-line no-use-before-define,@typescript-eslint/no-use-before-define

    var translatedNestedErrors = translateErrors(translations, errors);
    return _objectSpread2({}, error, {
      message: translatedMessage,
      errors: translatedNestedErrors
    });
  }

  return error;
});
var translateErrors = curry(function (translations, errors, key) {
  return errors ? errors.map(translateError(translations)(key)) : [];
});

export { PAYMENT_TYPE, Regex, string as String, downloadFile, formatBytes, fromBase64, generateQrPaymentValue, getKeyByValue, imageDimensions, internetExplorerTextEncoder, isEmail, isEmpty, isPhoneNumber, notEmpty, pushAppSent, pushButtonClicked, pushFormAction, pushKeyPress, pushPageVisited, translateError, translateErrors };
